export const groupAOffenseCodes = [
  '09A',
  '09B',
  '09C',
  '100',
  '11A',
  '11B',
  '11C',
  '11D',
  '120',
  '13A',
  '13B',
  '13C',
  '200',
  '210',
  '220',
  '23A',
  '23B',
  '23C',
  '23D',
  '23E',
  '23F',
  '23G',
  '23H',
  '240',
  '250',
  '26A',
  '26B',
  '26C',
  '26D',
  '26E',
  '26F',
  '26G',
  '270',
  '280',
  '290',
  '35A',
  '35B',
  '36A',
  '36B',
  '370',
  '39A',
  '39B',
  '39C',
  '39D',
  '40A',
  '40B',
  '40C',
  '510',
  '520',
  '64A',
  '64B',
  '720',
];
